import React, { ReactNode } from 'react'
import { Avatar, Col, Divider, Row } from 'antd'
import styled from '@emotion/styled'
import { OrderInfo, AddressCache } from 'components/Orders/Info/type'
import {
  formatFulfillmentDate,
  formatFulfillmentTime,
  getIcon
} from 'components/Orders/Info/utils'
import moment from 'moment-timezone'
import FulfillmentTimeRangeForm from '../Delivery/Forms/FulfillmentTimeRangeForm'

interface PickupDetailsProps {
  order: OrderInfo
  reloadOrder: () => void
}

interface DetailProps {
  type: string
  content: string | ReactNode
}

interface AddressProps {
  address: AddressCache
}

const PickupDetails = ({ order, reloadOrder }: PickupDetailsProps) => {
  const { store, inserted_at } = order
  const {
    name: store_name,
    address_cache: store_address_cache,
    address
  } = store

  const orderInsertedAt = moment(inserted_at).format()
  const addressUpdatedAt = moment(address?.updated_at).format()

  const storeAddress = moment(orderInsertedAt).isAfter(addressUpdatedAt)
    ? address
    : JSON.parse(store_address_cache)

  const Address = ({ address }: AddressProps) => {
    const { address: street, city, zip } = address || {}
    return (
      <>
        <Row className='_mb-0'>
          <Col>{`${street}, ${city}`}</Col>
        </Row>
        <Row className='_mb-0'>
          <Col>{zip}</Col>
        </Row>
      </>
    )
  }

  const Detail = ({ type, content }: DetailProps) => (
    <Row align='middle' className='_mb-0'>
      <Col span={4}>
        <Avatar size={32} style={{ color: '#4a4a68' }} icon={getIcon(type)} />
      </Col>
      <Col span={20} className='_cl-text-detail _capitalize'>
        {content}
      </Col>
    </Row>
  )

  return (
    <Row className='_mb-0'>
      <Col span={24} className='_p-16'>
        <Row className='_mb-2'>
          <LabelCol span={12}>Pickup from:</LabelCol>
        </Row>
        <Row align='middle'>
          <Col span={12}>
            <Detail type='store' content={store_name} />
          </Col>
          <Col span={12}>
            <Detail
              type='location'
              content={<Address address={storeAddress} />}
            />
          </Col>
        </Row>
        <Divider className='_mt-12 _mb-12' />

        <Row className='_mb-2'>
          <LabelCol span={12}>Fulfillment date and time:</LabelCol>
        </Row>
        <Row className='_mb-2' align='middle'>
          <Col span={12}>
            <Row align='middle' className='_mb-0'>
              <Col span={24}>
                <Detail
                  type='datestamp'
                  content={formatFulfillmentDate(order)}
                />
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row align='middle' className='_mb-0'>
              <Col span={24}>
                <Detail
                  type='timestamp'
                  content={formatFulfillmentTime(order)}
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <Divider className='_mt-12 _mb-12' />
        <FulfillmentTimeRangeForm
          order={order}
          successCallback={() => reloadOrder()}
        />
      </Col>
    </Row>
  )
}

const LabelCol = styled(Col)`
  color: #77778e;
`

export default PickupDetails
